import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { RbUiComponentsModule } from '@inst-iot/bosch-angular-ui-components';

import { FleetMgmtRoutingModule } from './fleet-mgmt-routing.module';

import { FleetMgmtComponent } from './fleet-mgmt/fleet-mgmt.component';
import { GeneralFleetComponent } from './general-fleet/general-fleet.component';
import { ChargingFleetComponent } from './charging-fleet/charging-fleet.component';
import { DutycycleFleetComponent } from './dutycycle-fleet/dutycycle-fleet.component';
import { CurrentSohcChartComponent } from './current-sohc-chart/current-sohc-chart.component';
import { VehicleMileageChartComponent } from './vehicle-mileage-chart/vehicle-mileage-chart.component';
import { AvgFleetEfficiencyChartComponent } from './avg-fleet-efficiency-chart/avg-fleet-efficiency-chart.component';
import { ChargedEnergyOverTimeChartComponent } from './charged-energy-over-time-chart/charged-energy-over-time-chart.component';
import { EquivalentFullChargeCyclesChartComponent } from './equivalent-full-charge-cycles-chart/equivalent-full-charge-cycles-chart.component';
import { SocDeltaPerChargingProcedureChartComponent } from './soc-delta-per-charging-procedure-chart/soc-delta-per-charging-procedure-chart.component';
import { SocStartChartComponent } from './soc-start-chart/soc-start-chart.component';
import { SocEndChartComponent } from './soc-end-chart/soc-end-chart.component';
import { SocEventsLowComponent } from './soc-events-low/soc-events-low.component';
import { SocEventsHighComponent } from './soc-events-high/soc-events-high.component';
import { TemperatureComfortZoneChartComponent } from './temperature-comfort-zone-chart/temperature-comfort-zone-chart.component';
import { TimeSpentExtremeTempHighChartComponent } from './time-spent-extreme-temp-high-chart/time-spent-extreme-temp-high-chart.component';
import { TimeSpentExtremeTempLowChartComponent } from './time-spent-extreme-temp-low-chart/time-spent-extreme-temp-low-chart.component';
import { TimeSpentExtremeTempChartComponent } from './time-spent-extreme-temp-chart/time-spent-extreme-temp-chart.component';
import { SharedPipesModule } from 'src/app/_shared/modules/shared-pipes.module';
import { StressFactorsFleetComponent } from './stress-factors-fleet/stress-factors-fleet.component';
import { BatteryConditionChartComponent } from './battery-condition-chart/battery-condition-chart.component';
import { EvBatteryConditionChartComponent } from './ev-battery-condition-chart/ev-battery-condition-chart.component';
import { BatteryConditionPredictedChartComponent } from './battery-condition-predicted-chart/battery-condition-predicted-chart.component';
import { PredictedSohcChartComponent } from './predicted-sohc-chart/predicted-sohc-chart.component';
import { VehicleOfNoteComponent } from './vehicle-of-note/vehicle-of-note.component';
import { CircularProgressComponent } from 'src/app/_shared/components/utils/circular-progress/circular-progress.component';
import { AtomicAgingComponent } from './atomic-aging/atomic-aging.component';

@NgModule({
  declarations: [
    FleetMgmtComponent,
    GeneralFleetComponent,
    ChargingFleetComponent,
    DutycycleFleetComponent,
    CurrentSohcChartComponent,
    VehicleMileageChartComponent,
    AvgFleetEfficiencyChartComponent,
    ChargedEnergyOverTimeChartComponent,
    EquivalentFullChargeCyclesChartComponent,
    SocDeltaPerChargingProcedureChartComponent,
    SocStartChartComponent,
    SocEndChartComponent,
    SocEventsLowComponent,
    SocEventsHighComponent,
    TemperatureComfortZoneChartComponent,
    TimeSpentExtremeTempHighChartComponent,
    TimeSpentExtremeTempLowChartComponent,
    TimeSpentExtremeTempChartComponent,
    StressFactorsFleetComponent,
    BatteryConditionChartComponent,
    EvBatteryConditionChartComponent,
    BatteryConditionPredictedChartComponent,
    PredictedSohcChartComponent,
    VehicleOfNoteComponent,
    AtomicAgingComponent,
    /* CircularProgressComponent */
  ],
  imports: [
    CommonModule,
    FormsModule,
    CircularProgressComponent,
    /* FleetMgmtRoutingModule, */
    RbUiComponentsModule,
    SharedPipesModule
  ],
  exports: [FleetMgmtComponent]
})
export class FleetMgmtModule { }
